var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Nav'),(_vm.success_page)?_c('SuccessPage'):_c('CheckoutView',{on:{"to-success-page":function($event){return _vm.successPage()}}}),(_vm.displayInstructionBar)?_c('InstructionsBar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }